import { URL } from '../constants';
import { opsApiInstance } from '../instance';

import { EmployeeDocument, EmployeeDocumentUrl } from './types';

export type { EmployeeDocument, EmployeeDocumentUrl } from './types';

/**
 * A 5-minute signed URL for an employee's W-9 or contract. OPS answers only
 * the employee themself, Company Owner / Administrative / Accounting of the
 * same company and Site Admin; the files themselves are private.
 */
export const getEmployeeDocumentUrl = (
  employeeId: number,
  document: EmployeeDocument
) =>
  opsApiInstance.get<EmployeeDocumentUrl>(URL.UPLOAD_FILE, {
    params: { document, employeeId },
    // A missing document is a normal answer here, not a reason to leave the
    // page for the 404 screen.
    headers: { 'allow-not-found': 'true' },
  });

/**
 * A 5-minute signed URL for one signed onboarding document (plan 07 §4.2).
 * Readers: the employee themself and Company Owner / Administrative /
 * Accounting of the same company (the signed W-9 holds the full SSN or EIN).
 */
export const getOnboardingDocumentUrl = (onboardingDocumentId: number) =>
  opsApiInstance.get<EmployeeDocumentUrl>(URL.UPLOAD_FILE, {
    params: { onboardingDocumentId },
    headers: { 'allow-not-found': 'true' },
  });

// "Download all": a package's signed documents in one PDF (owner, 26 Oct).
export const getOnboardingAllCopiesUrl = (onboardingPackageId: number) =>
  opsApiInstance.get<EmployeeDocumentUrl>(URL.UPLOAD_FILE, {
    headers: { 'allow-not-found': 'true' },
    params: { onboardingAllCopies: onboardingPackageId },
  });
